export class HttpStatus {
  public static readonly NotFound: number = 404;
}
